import {useMemo} from "react";
import SentryEchart from "../../../../../components/echarts/sentry-echart.jsx";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import {DASH_BREAKPOINTS, fluidPx} from "../../../../../utils/responsive-graph.js";

export default function AnalyticsCard({usersAnalytics}) {
    const vw = useGraphViewportWidth();
    const associativeWizard = usersAnalytics?.associativeWizard ?? 0;
    const proximityAnalysis = usersAnalytics?.proximityAnalysis ?? 0;
    const vehicleProfile = usersAnalytics?.vehicleProfile ?? 0;

    const option = useMemo(() => {
        const isCompact = vw < DASH_BREAKPOINTS.desktop;
        const legendFs = fluidPx(11, 24, vw);
        const legendValues = {
            "Associabilidade": associativeWizard,
            "Proximidade": proximityAnalysis,
            "Perfil de veículo": vehicleProfile
        };
        const total = Object.values(legendValues).reduce((sum, value) => sum + value, 0);
        const totalFs = fluidPx(14, 28, vw);
        const pieCenter = isCompact ? ["27%", "43%"] : ["30%", "43%"];
        const pieRadius = isCompact ? ["44%", "57%"] : ["53%", "69%"];
        const legendLayout = {
            right: isCompact ? "5%" : "12%",
            top: isCompact ? "21%" : "19%",
            orient: "vertical"
        };

        return {
            tooltip: {
                show: true,
                formatter: (params) => `${params.name}: ${params.value} (${params.percent.toFixed(0)}%)`
            },
            title: {
                text: String(total),
                left: pieCenter[0],
                top: pieCenter[1],
                textAlign: "center",
                textVerticalAlign: "middle",
                padding: 0,
                textStyle: {
                    color: "#E8E8E8",
                    fontSize: totalFs,
                    fontWeight: 600
                }
            },
            legend: {
                ...legendLayout,
                icon: "circle",
                textStyle: {
                    fontSize: legendFs,
                    rich: {
                        value: {
                            color: "#E8E8E8",
                            fontSize: legendFs,
                            fontWeight: 500
                        },
                        label: {
                            color: "#AAAAAA",
                            fontSize: legendFs,
                            fontWeight: 300
                        }
                    }
                },
                formatter: (name) => `{value|${legendValues[name] ?? 0}}  {label|${name}}`
            },
            series: [
                {
                    type: "pie",
                    radius: pieRadius,
                    center: pieCenter,
                    silent: true,
                    animation: false,
                    tooltip: {show: false},
                    label: {show: false},
                    labelLine: {show: false},
                    z: 1,
                    data: [
                        {
                            value: 1,
                            itemStyle: {
                                color: "rgba(255, 255, 255, 0.08)"
                            }
                        }
                    ]
                },
                {
                    type: "pie",
                    radius: pieRadius,
                    center: pieCenter,
                    avoidLabelOverlap: true,
                    z: 2,
                    itemStyle: {
                        borderRadius: 20
                    },
                    label: {show: false},
                    data: [
                        {
                            value: legendValues["Associabilidade"],
                            name: "Associabilidade",
                            itemStyle: {color: "#2acbe2"}
                        },
                        {
                            value: legendValues["Proximidade"],
                            name: "Proximidade",
                            itemStyle: {color: "#187dd2"}
                        },
                        {
                            value: legendValues["Perfil de veículo"],
                            name: "Perfil de veículo",
                            itemStyle: {color: "#004893"}
                        }
                    ],
                    labelLine: {
                        show: false
                    }
                }
            ]
        };
    }, [associativeWizard, proximityAnalysis, vehicleProfile, vw]);

    return (
        <article className="col-span-2 min-h-0 h-full row-start-2">
            <SentryEchart
                className="h-full min-h-0"
                option={option}
                title="Análises"
                titleClass={vw < DASH_BREAKPOINTS.desktop ? "mt-2! mb-0!" : "mt-[20px]! mb-0!"}
            />
        </article>
    );
}
